/**
 * The brand wordmark. Always lowercase `acel·cortex` with a green interpunct.
 * Per the design system: never capitalize, never replace the dot.
 */
export function Wordmark({ size = 22 }: { size?: number }) {
  return (
    <span
      style={{
        fontFamily: 'var(--font-sans)',
        fontWeight: 500,
        fontSize: `${size}px`,
        letterSpacing: 'var(--tracking-wordmark)',
        color: 'var(--ink)',
        lineHeight: 1,
      }}
    >
      acel<span style={{ color: 'var(--green)' }}>·</span>cortex
    </span>
  );
}
